import styled from 'styled-components';

export const Container = styled.div``;
export const Header = styled.div`
    background: rgb(4,236,161);
    background: linear-gradient(262deg, rgba(4,236,161,1) 21%, rgba(98,205,255,1) 70%);
    height: 150px;
    text-align: center;
    box-shadow: 0px 15px 15px -3px rgba(0,0,0,0.1);
`;
export const HeaderText = styled.h1`
    margin: 0;
    padding: 0;
    color: #FFF;
    padding-top: 30px;
`;
export const Body = styled.div`
    margin: auto;
    max-width: 980px;  
    margin-bottom: 50px; 
`;